import React from 'react';
import Chart from 'react-apexcharts';

const EngagementRateChart = ({ engagementData, engage_interval_duration, duration }) => {
  if (!engagementData || engagementData.length === 0) {
    return <div>Loading chart data...</div>;
  }

  // --- Calculate categories for X-axis ---
  const categories = engagementData.map((_, index) => {
    const start = index * (engage_interval_duration || 0);
    const isLastIndex = index === engagementData.length - 1;
    const end = isLastIndex ? duration : (index + 1) * (engage_interval_duration || 0);
    return `${start}-${end}`;
  });

  const series = [
    { name: 'Engagement Rate', data: engagementData },
    { name: 'Remaining', data: engagementData.map(value => 100 - value) }
  ];

  // --- Responsive settings ---
  const isMobile = window.innerWidth <= 768;
  const offsetY = isMobile ? 0 : 7;

  // Make bars slimmer like tube for mobile
  const columnWidth = isMobile ? '35%' : '20%';
  const borderRadius = isMobile ? 5 : 8;

  const options = {
    chart: {
      type: 'bar',
      height: 350,
      stacked: true,
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: borderRadius,
        columnWidth: columnWidth,
      },
    },
    colors: ['#0E5D9D', '#E9ECEF'],
    dataLabels: { enabled: false },
    grid: {
      strokeDashArray: 4,
      borderColor: '#EAEFF7',
    },
    xaxis: {
      categories: categories,
      title: {
        text: `Period Duration: ${duration} (Min)`,
        offsetY: offsetY,
        style: {
          color: '#6c757d',
          fontSize: '13px',
          fontWeight: 400,
        },
      },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      min: 0,
      max: 100,
      labels: {
        formatter: (val) => (val === 0 ? '0' : val + '%'),
      },
    },
    legend: { show: false },
    states: {
      hover: { filter: { type: 'none' } },
      active: { filter: { type: 'none' } },
    },

    tooltip: {
      shared: false,
      theme: "dark",
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        if (seriesIndex === 1) return '';

        const value = series[seriesIndex][dataPointIndex];
        const category = w.globals.labels[dataPointIndex];

        return `
          <div style="
            background: black; 
            color: white; 
            padding: 8px 8px;
            font-family: 'Archivo', sans-serif;
            font-size: 12px;
          ">
            <strong>Between ${category} min</strong><br/>
            Engagement Rate: ${value}%
          </div>
        `;
      },
    },
  };

  return (
    <div className="chart-wrapper">
      <Chart options={options} series={series} type="bar" height={300} />
    </div>
  );
};

export default EngagementRateChart;
